import { HttpHelper } from "./HttpHelper"

export abstract class HelperHelper{
    private static baseUrl = HttpHelper.GetUrlBaseApi() + "api/" + "Helper"
    
    public static async GetIpAddress(){
        var urlForRequest = this.baseUrl + "/client-ip";
        return (await HttpHelper.GetRequestForApi<string>(urlForRequest))
    }
}